import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SendQueuedEmailNow as SendQueuedEmailNowMutation,
    SendQueuedEmailNowVariables,
    EmailQueuedSendNowInput,
} from 'nutshell-graphql-types';

import SEND_QUEUED_EMAIL_NOW from '../mutations/send-queued-email-now.graphql';

export const useSendQueuedEmailNow = (): {
    sendQueuedEmailNow: (arg1: EmailQueuedSendNowInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [sendQueuedEmailNow, {loading, error}] = useMutation<
        SendQueuedEmailNowMutation,
        SendQueuedEmailNowVariables
    >(SEND_QUEUED_EMAIL_NOW);

    return {
        sendQueuedEmailNow: (input: EmailQueuedSendNowInput) =>
            sendQueuedEmailNow({variables: {payload: input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
